module.exports = __webpack_public_path__ + "img/DE01416.ef5d8348.png";